<template>
  <div class="subscription-information mt-5 mb-1 lg:mt-10 lg:mb-4">
    <the-section :title="$t('ec-line005.subscriptionInformation.title')">
      <div class="el-form el-form--label-top">
        <card-item :label="$t('common.label.subscriptionId')" :value="data.subscription_id"></card-item>
        <card-item :label="$t('common.label.deliveryPattern')" :value="data.delivery_pattern"></card-item>
        <card-item
          :label="$t('common.label.deliveryInterval')"
          :value="
            $t('ec-line005.content.deliveryIntervalNote', {
              month: data.delivery_interval,
              date: $date.getDate(data.next_delivery_date),
            })
          "
        ></card-item>
        <card-item
          :label="$t('ec-line005.subscription.firstDeliveryDate')"
          :value="Utils.date.formatDateJP(data.next_delivery_date)"
        ></card-item>
        <card-item
          :label="$t('ec-line005.subscription.secondDeliveryDate')"
          :value="Utils.date.formatDateJP(data.next_next_delivery_date)"
        ></card-item>
      </div>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import CardItem from './CardInfoItem.vue'
export default {
  components: { TheSection, CardItem },
  props: {
    data: { type: Object, default: () => {} },
  },
}
</script>
